var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.audioPlayerPosition }, [
    _vm.audioInfo.inboundNumber && _vm.recording
      ? _c("div", { staticClass: "audio-player__inbound-number" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("INBOUND_NUMBER") + " " + _vm.audioInfo.inboundNumber
              ) +
              "\n  "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "audio-player__close btn btn-function",
        attrs: { target: "javascript:void(0)" },
        on: { click: _vm.hidePlayer }
      },
      [_c("i", { staticClass: "fa fa-close f-s-13 p-r-0" })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "audio-player__controls" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-function",
          attrs: {
            href: "javascript:void(0);",
            disabled: _vm.paused,
            "data-testid": "v2-reporting-audio-player-back-btn"
          },
          on: {
            click: function($event) {
              return _vm.fastForwardOrBackward("backward", true)
            },
            mousedown: function($event) {
              return _vm.fastForwardOrBackward("backward", false)
            },
            mouseup: function($event) {
              return _vm.resumePlay()
            }
          }
        },
        [_c("i", { staticClass: "fa fa-backward" })]
      ),
      _vm._v(" "),
      !_vm.paused && _vm.currentTime > 0
        ? _c(
            "a",
            {
              staticClass: "btn btn-function",
              attrs: {
                href: "javascript:void(0);",
                "data-testid": "v2-reporting-audio-player-pause-btn"
              },
              on: {
                click: function($event) {
                  return _vm.pause()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-pause" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.paused || _vm.currentTime === 0
        ? _c(
            "a",
            {
              staticClass: "btn btn-function",
              attrs: {
                href: "javascript:void(0);",
                "data-testid": "v2-reporting-audio-player-play-btn"
              },
              on: {
                click: function($event) {
                  return _vm.play()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-play" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-function",
          attrs: {
            href: "javascript:void(0);",
            disabled: _vm.paused && _vm.currentTime > 0
          },
          on: {
            click: function($event) {
              return _vm.fastForwardOrBackward("forward", true)
            },
            mousedown: function($event) {
              return _vm.fastForwardOrBackward("forward", false)
            },
            mouseup: function($event) {
              return _vm.resumePlay()
            }
          }
        },
        [_c("i", { staticClass: "fa fa-forward" })]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-function audio-player__playback-stack",
          attrs: {
            href: "javascript:void(0);",
            disabled: _vm.paused && _vm.currentTime > 0
          },
          on: {
            click: function($event) {
              return _vm.setPlaybackRate()
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-undo fa-flip-horizontal" }),
          _vm._v(" "),
          _c("span", { staticClass: "audio-player__playback-rate" }, [
            _vm._v(
              _vm._s(
                _vm.recording.playbackRate
                  ? _vm.recording.playbackRate + "x"
                  : "1x"
              )
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "audio-player__remaining-time" }, [
        _vm._v(
          "\n      - " +
            _vm._s(
              _vm.formatTime(
                Math.floor(_vm.duration) - Math.floor(_vm.currentTime)
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-function pull-right m-l-10 m-t-2",
          attrs: {
            href: _vm.audioInfo.recordingUrl,
            target: "_blank",
            title: "Download",
            download: ""
          }
        },
        [_c("i", { staticClass: "fa fa-download f-s-13 p-r-0" })]
      ),
      _vm._v(" "),
      _vm.audioInfo.hasTranscription
        ? _c(
            "a",
            {
              staticClass: "btn btn-function pull-right m-l-10 m-t-2",
              attrs: {
                title: "View Transcription",
                href: "javascript:void(0);"
              },
              on: { click: _vm.viewTranscription }
            },
            [_c("i", { staticClass: "fa fa-file-text-o f-s-13 p-r-0" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.recording.currentTime,
            expression: "recording.currentTime"
          }
        ],
        staticClass: "m-t-10",
        attrs: {
          type: "range",
          step: _vm.duration / 100,
          min: "0",
          max: _vm.duration
        },
        domProps: { value: _vm.recording.currentTime },
        on: {
          __r: function($event) {
            return _vm.$set(_vm.recording, "currentTime", $event.target.value)
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }